"use client"
import React from "react";
import ReactDOM from "react-dom";
interface ConfirmationProps {
  onClose: () => void;
//   onConfirm: () => void;
 title:string;
 body:string;
 closeButtonName:string;
}
const DynamicSuccessPopup: React.FC<ConfirmationProps> = ({
  onClose,
//   onConfirm,
  title,
  body,
  
  closeButtonName,
  
}) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-[600px] w-10/12">
        <div className="p-7">
          <div className="flex items-center justify-center">
            <div className="ml-4">
                <h3 className="text-2xl font-bold text-gray-900 text-center">
                 {title}
                </h3>
                <p className="text-base leading-7 font-normal text-gray-900 text-center mt-5 mb-3">
                 {body}
                </p>
              
            </div>
          </div>
        </div>
        <div
          className="bg-white px-4 py-4 sm:px-6 sm:flex justify-center sm:flex-row-revers"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-custom-gradients text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2"
            onClick={onClose}
          >
            {closeButtonName}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DynamicSuccessPopup
